import { CONTACT, NAV_LINKS, SERVICES, whatsappLink } from "../content/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#060607] border-t border-white/5 pt-20 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16">
        <div>
          <a href="#home" data-testid="footer-logo" className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-lg bg-[#0055FF] flex items-center justify-center font-display font-black text-white text-sm">W</span>
            <span className="font-display font-extrabold text-lg tracking-tight text-white">Web<span className="text-gradient-blue">Studios</span></span>
          </a>
          <p className="mt-4 font-display text-xl font-bold text-neutral-300 tracking-tight">Websites built.<br />Websites managed.</p>
          <p className="mt-4 text-sm text-neutral-500 leading-relaxed">You focus on your business. We take care of your website.</p>
        </div>
        <nav aria-label="Footer navigation">
          <p className="font-mono2 text-xs tracking-widest uppercase text-neutral-500 mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-neutral-400 hover:text-white transition-colors duration-200">{l.label}</a>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Footer services">
          <p className="font-mono2 text-xs tracking-widest uppercase text-neutral-500 mb-5">Services</p>
          <ul className="space-y-3">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.id}>
                <a href="#services" data-testid={`footer-service-${s.id}`} className="text-sm text-neutral-400 hover:text-white transition-colors duration-200">{s.title}</a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="font-mono2 text-xs tracking-widest uppercase text-neutral-500 mb-5">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="text-[#25D366] hover:text-[#4be584] transition-colors duration-200 font-medium">
                WhatsApp: {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="text-neutral-400 hover:text-white transition-colors duration-200 break-all">
                {CONTACT.email}
              </a>
            </li>
          </ul>
          <a href="#contact" data-testid="footer-quote-cta"
            className="mt-6 inline-flex items-center gap-2 bg-[#0055FF] hover:bg-[#0044CC] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200">
            Get a Free Quote
          </a>
          <p className="mt-4">
            <a href="/pay" data-testid="footer-pay-link" className="text-xs text-neutral-500 hover:text-cyan-300 transition-colors duration-200">Pay for a plan online →</a>
          </p>
        </div>
      </div>
      <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-neutral-600">© {new Date().getFullYear()} WebStudios. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <a href="/privacy" data-testid="footer-privacy" className="text-xs text-neutral-600 hover:text-neutral-300 transition-colors duration-200">Privacy Policy</a>
          <a href="/terms" data-testid="footer-terms" className="text-xs text-neutral-600 hover:text-neutral-300 transition-colors duration-200">Terms & Conditions</a>
          <a href="/cookies" data-testid="footer-cookies" className="text-xs text-neutral-600 hover:text-neutral-300 transition-colors duration-200">Cookie Policy</a>
        </div>
      </div>
    </div>
    <p aria-hidden="true" className="pointer-events-none select-none font-display font-black tracking-tighter text-white/[0.025] text-[22vw] leading-none absolute -bottom-[6vw] left-1/2 -translate-x-1/2 whitespace-nowrap">
      WebStudios
    </p>
  </footer>
);
